/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {BS2Statics} from "./config/BS2Statics";

export class BS2GameAssets {
    static BITMAP_FONT_OPENSANS_800: string = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP: string = "NumbersWinCountUp";
    static BITMAP_FONT_CANDLE_NUMBER: string = "CandleNumbers";
    static BITMAP_FONT_MULTIPLIER_NUMBER: string = "multiplier";
    static BIG_WIN_SPINE_LEVEL_1: string = "spine/BigWinAnimations/BW1.json";
    static BIG_WIN_SPINE_LEVEL_2: string = "spine/BigWinAnimations/BW2.json";
    static BIG_WIN_SPINE_LEVEL_3: string = "spine/BigWinAnimations/BW3.json";
    static BIG_WIN_SPINE_LEVEL_4: string = "spine/BigWinAnimations/BW4.json";
    static BIG_WIN_SPINE_LEVEL_5: string = "spine/BigWinAnimations/BW5.json";
    static MAX_WIN_SPINE: string = "spine/BigWinAnimations/WinCap.json";
    static SYMBOL_HIGHLIGHT_ANIMATION: string = "SymWinHighlight";
    static SYMBOL_WIN_EXPLOSION_ANIMATION: string = "SymExplosion";
    static L1_SPINE: string = "spine/symbols/L1.json";
    static L2_SPINE: string = "spine/symbols/L2.json";
    static L3_SPINE: string = "spine/symbols/L3.json";
    static L4_SPINE: string = "spine/symbols/L4.json";
    static L5_SPINE: string = "spine/symbols/L5.json";
    static M1_SPINE: string = "spine/symbols/M1.json";
    static M2_SPINE: string = "spine/symbols/M2.json";
    static M3_SPINE: string = "spine/symbols/M3.json";
    static M4_SPINE: string = "spine/symbols/M4.json";
    static M5_SPINE: string = "spine/symbols/M5.json";
    static H1_SPINE: string = "spine/symbols/H1.json";
    static H2_SPINE: string = "spine/symbols/H2.json";
    static H3_SPINE: string = "spine/symbols/H3.json";
    static H4_SPINE: string = "spine/symbols/H4.json";
    static H5_SPINE: string = "spine/symbols/H5.json";

    static G_SPINE: string = "spine/symbols/G.json";
    static D_SPINE: string = "spine/symbols/D.json";
    static W_SPINE: string = "spine/symbols/w.json";
    static S_SPINE: string = "spine/symbols/scatter.json";
    static Y_SPINE: string = "spine/symbols/Y.json";

    static BACKGROUND_SPINE: string = "spine/backgroundSpine_test (1).json";
    static REEL_FRAME_SPINE: string = "spine/ReelFrame.json";
    static BAT_SPINE: string = "spine/bat.json";

    static CANDLE_FLAME_SPINE: string = "spine/FrameCandle.json";

    static SYMBOL_HIGHLIGHT_OVERLAY: string = "highlight_attention";
    static SYMBOL_HIGHLIGHT_OVERLAY_FRAME: string = "glow_frame";


    static OUTRO_OUTER_CIRCLE: string = "FS_Outro/outroOuterCircle";
    static OUTRO_INNER_CIRCLE: string = "FS_Outro/outroInnerCircle";
    static OUTRO_MIDDLE_CIRCLE: string = "FS_Outro/outroMiddleCircle";
    static OUTRO_INK_STREAK: string = "FS_Outro/InkStreak";
    static TRANSITION_HOT_FRAME: string = "HotFrame";

    static NEAR_WIN_SPINE: string = "spine/nearWin.json";
    static SIGILL_LVL_1: string = "spine/levels/sigil_1.json";
    static SIGILL_LVL_2: string = "spine/levels/sigil_2.json";
    static SIGILL_LVL_3: string = "spine/levels/sigil_3.json";
    static SIGILL_LVL_4: string = "spine/levels/sigil_4.json";
    static SIGILL_LVL_5: string = "spine/levels/sigil_5.json";


    static SPLIT_LINE_HORIZONTAL: string = "xLineHorizontal";
    static SPLIT_LINE_HORIZONTAL_GLOW: string = "xLineHorizontalGlow";
    static SPLIT_LINE_VERTICAL: string = "xLineVertical";
    static SPLIT_LINE_VERTICAL_GLOW: string = "xLineVerticalGlow";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(BS2GameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(BS2GameAssets.BITMAP_FONT_CANDLE_NUMBER, "fonts/bitmapfonts/CandleNumbers.fnt"),
                    new BitmapFontAsset(BS2GameAssets.BITMAP_FONT_MULTIPLIER_NUMBER, "fonts/bitmapfonts/multiplier.fnt"),
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("SigilFlares", "spine/SigilFlares.json"),
                    new SpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_1, BS2GameAssets.BIG_WIN_SPINE_LEVEL_1),
                    new SpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_2, BS2GameAssets.BIG_WIN_SPINE_LEVEL_2),
                    new SpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_3, BS2GameAssets.BIG_WIN_SPINE_LEVEL_3),
                    new SpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_4, BS2GameAssets.BIG_WIN_SPINE_LEVEL_4),
                    new SpineAsset(BS2GameAssets.BIG_WIN_SPINE_LEVEL_5, BS2GameAssets.BIG_WIN_SPINE_LEVEL_5),
                    new SpineAsset(BS2GameAssets.MAX_WIN_SPINE, BS2GameAssets.MAX_WIN_SPINE),
                    new SpineAsset(BS2GameAssets.L1_SPINE, BS2GameAssets.L1_SPINE),
                    new SpineAsset(BS2GameAssets.L2_SPINE, BS2GameAssets.L2_SPINE),
                    new SpineAsset(BS2GameAssets.L3_SPINE, BS2GameAssets.L3_SPINE),
                    new SpineAsset(BS2GameAssets.L4_SPINE, BS2GameAssets.L4_SPINE),
                    new SpineAsset(BS2GameAssets.L5_SPINE, BS2GameAssets.L5_SPINE),
                    new SpineAsset(BS2GameAssets.M1_SPINE, BS2GameAssets.M1_SPINE),
                    new SpineAsset(BS2GameAssets.M2_SPINE, BS2GameAssets.M2_SPINE),
                    new SpineAsset(BS2GameAssets.M3_SPINE, BS2GameAssets.M3_SPINE),
                    new SpineAsset(BS2GameAssets.M4_SPINE, BS2GameAssets.M4_SPINE),
                    new SpineAsset(BS2GameAssets.M5_SPINE, BS2GameAssets.M5_SPINE),
                    new SpineAsset(BS2GameAssets.H1_SPINE, BS2GameAssets.H1_SPINE),
                    new SpineAsset(BS2GameAssets.H2_SPINE, BS2GameAssets.H2_SPINE),
                    new SpineAsset(BS2GameAssets.H3_SPINE, BS2GameAssets.H3_SPINE),
                    new SpineAsset(BS2GameAssets.H4_SPINE, BS2GameAssets.H4_SPINE),
                    new SpineAsset(BS2GameAssets.H5_SPINE, BS2GameAssets.H5_SPINE),
                    new SpineAsset(BS2GameAssets.NEAR_WIN_SPINE, BS2GameAssets.NEAR_WIN_SPINE),

                    new SpineAsset(BS2GameAssets.G_SPINE, BS2GameAssets.G_SPINE),
                    new SpineAsset(BS2GameAssets.D_SPINE, BS2GameAssets.D_SPINE),
                    new SpineAsset(BS2GameAssets.W_SPINE, BS2GameAssets.W_SPINE),
                    new SpineAsset(BS2GameAssets.S_SPINE, BS2GameAssets.S_SPINE),
                    new SpineAsset(BS2GameAssets.Y_SPINE, BS2GameAssets.Y_SPINE),
                    new SpineAsset(BS2GameAssets.BACKGROUND_SPINE, BS2GameAssets.BACKGROUND_SPINE),
                    new SpineAsset("spine/demon.json", "spine/demon.json"),

                    new SpineAsset(BS2GameAssets.REEL_FRAME_SPINE, BS2GameAssets.REEL_FRAME_SPINE),
                    new SpineAsset(BS2GameAssets.BAT_SPINE, BS2GameAssets.BAT_SPINE),

                    new SpineAsset(BS2GameAssets.CANDLE_FLAME_SPINE, BS2GameAssets.CANDLE_FLAME_SPINE),

                    new SpineAsset(BS2GameAssets.SIGILL_LVL_1, BS2GameAssets.SIGILL_LVL_1),
                    new SpineAsset(BS2GameAssets.SIGILL_LVL_2, BS2GameAssets.SIGILL_LVL_2),
                    new SpineAsset(BS2GameAssets.SIGILL_LVL_3, BS2GameAssets.SIGILL_LVL_3),
                    new SpineAsset(BS2GameAssets.SIGILL_LVL_4, BS2GameAssets.SIGILL_LVL_4),
                    new SpineAsset(BS2GameAssets.SIGILL_LVL_5, BS2GameAssets.SIGILL_LVL_5)
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                ],
                animations: {
                    [BS2GameAssets.SYMBOL_WIN_EXPLOSION_ANIMATION]: "FX/SymbolWin/SymbolWin_",
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json")
                ],
                animations: {
                    [BS2GameAssets.SYMBOL_HIGHLIGHT_ANIMATION]: "SymWinFX/WinFx_",
                    "shockWaveEffect": "Effects/Shockwave/Shockwave_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "bottomStickyWildLocker": "W/Branch_FX/Branch_FX_"
                }
            }
        ]
    };


    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            if (symbolName == "EM") {
                return symbolName + "/" + BS2Statics.EM_SYMBOLS.next();
            }

            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}